import React, { ElementType } from "react"
import classNames from "classnames"

interface HeadingProps {
  children: string
  align?: "left" | "center" | "right"
  level: 1 | 2 | 3 | 4
}

export const Heading = ({ children, align = "left", level }: HeadingProps) => {
  const className = classNames({
    "w-full text-gray-900 antialiased": true,
    "text-h1-mobile font-medium md:text-h1-desktop": level === 1,
    "text-h2-mobile font-medium md:text-h2-desktop": level === 2,
    "text-h3-mobile font-medium md:text-h3-desktop": level === 3,
    "text-h4-mobile font-semibold md:text-h4-desktop": level === 4,
    "text-left": align === "left",
    "text-center": align === "center",
    "text-right": align === "right",
  })

  const H: ElementType = `h${level}`

  return <H className={className}>{children}</H>
}
